<template>
  <div class="ele-body">
    <el-card shadow="never" v-loading="loading" body-style="padding-bottom: 0;">
      <el-row :gutter="15">
        <el-col :md="4" style="margin-bottom: 15px">
          <!-- 区域列表 -->
          <div class="org-tree-group">
            <el-tree
              ref="orgTree"
              :data="deptData"
              :props="{ label: 'name' }"
              :expand-on-click-node="true"
              node-key="id"
              :default-expanded-keys="dataIdArr"
              @node-click="chooseClass"
              highlight-current
            />
          </div>
        </el-col>
        <el-col :md="20" style="margin-bottom: 15px">
          <course-list ref="courseList" />
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
  import courseList from './course-list';
  import { finiteDataTree } from '@/config/api';
  export default {
    name: 'Index',
    components: { courseList },
    data() {
      return {
        loading: true, // 加载状态
        deptData: [], // 列表数据
        dataIdArr: [],
      };
    },
    mounted() {
      this.queryClassList();
    },
    methods: {
      queryClassList() {
        this.loading = true;
        finiteDataTree()
          .then((res) => {
            this.loading = false;
            if (res.data.resCode == 200) {
              this.deptData = res.data.data;
              this.dataIdArr = this.$util.getTreeFloor(this.deptData, 1, this.dataIdArr, 'id');
            } else {
              this.$message.error(res.data.data.resMsg || '获取数据失败');
            }
          })
          .catch((e) => {
            this.loading = false;
            this.$message.error(e.message);
          });
      },
      /* 选择班级数据 */
      chooseClass(row) {
        if (row.orgType === 4) {
          this.$refs.orgTree.setCurrentKey(row.id);
          let obj = {
            classId: row.id.slice(1),
          };
          this.$refs.courseList.classId = row.id.slice(1);
          this.$refs.courseList.table.where = obj;
          this.$refs.courseList.$refs.table.reload();
        } else {
          this.$refs.courseList.classId = null;
        }
      },
    },
  };
</script>

<style scoped>
  .org-tree-group {
    border: 1px solid hsla(0, 0%, 60%, 0.15);
    height: calc(100vh - 150px);
    box-sizing: border-box;
    overflow-x: auto;
  }

  .org-tree-group >>> .el-tree-node__content {
    height: 30px;
  }

  .org-tree-group >>> .el-tree-node__content > .el-tree-node__expand-icon {
    margin-left: 10px;
  }
</style>
